var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeloton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 102,
    viewBox: "0 0 74 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.0362 24.5308L69.6091 11.7117C71.8077 8.03213 70.4641 3.1656 66.6777 1.02908C62.8912 -1.10745 57.8834 0.198206 55.6848 3.87778L48.1119 16.6969C31.9889 11.7117 13.7896 18.1213 4.99524 33.0769C-0.623356 42.5726 -1.35622 53.3739 2.0638 62.9883L16.1103 39.3678C19.286 33.9078 24.5382 30.1095 30.7675 28.4478C36.9968 26.7861 43.4704 27.6169 49.089 30.8217C60.5705 37.2313 64.6012 51.7122 57.8834 62.8696C51.2876 74.027 36.5083 77.9439 24.9046 71.4157L32.9661 57.7657C36.7525 59.9022 41.7604 58.5965 43.959 54.917C46.1576 51.1187 44.814 46.3709 41.0276 44.2343C37.2411 42.0978 32.2332 43.4035 30.0346 47.083L4.38453 90.2883C2.18594 94.0866 3.52952 98.8344 7.31597 100.971C11.1024 103.107 16.1103 101.802 18.3089 98.1222L25.8818 85.3031C42.0047 90.2883 60.2041 83.8787 68.9984 68.9231C77.9149 54.0861 74.4949 35.6882 62.0362 24.5308Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeloton);
export default __webpack_public_path__ + "static/media/peloton.e53444f972f682bdf16570ecdf11b256.svg";
export { ForwardRef as ReactComponent };